export default "__VITE_PUBLIC_ASSET__af88467e__"